module.exports = __webpack_public_path__ + "static/media/error.3d976c43.svg";